import { useLocation } from 'react-router';
import { FullBox, Typography } from 'seagull';
import { AnchorLogo } from 'seagull/icons';
import styles from "./ExpiredProposalPage.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ExpiredProposalPage = () => {
  const {
    state
  } = useLocation();
  return /*#__PURE__*/_jsxs(FullBox, {
    centered: true,
    flexDirection: "column",
    className: styles.container,
    children: [/*#__PURE__*/_jsx(AnchorLogo, {
      theme: "dark",
      "data-testid": "expired-proposal-page-logo",
      height: 64
    }), /*#__PURE__*/_jsx(Typography, {
      variant: "h3",
      weight: "normal",
      testId: "expired-proposal-page-title",
      children: "This proposal has expired"
    }), /*#__PURE__*/_jsx(Typography, {
      variant: "h5",
      testId: "expired-proposal-page-subtitle",
      className: styles.subtitle,
      children: "We're sorry, but the proposal you are trying to access has expired and is no longer available. Please\n            contact ".concat((state === null || state === void 0 ? void 0 : state.vendorName) || 'your business provider', " if you have any questions or require further assistance.")
    })]
  });
};
export default ExpiredProposalPage;